import {FC} from 'react'
import {Link} from 'react-router-dom'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'

const Forbidden: FC = () => {
  const dashboardUrl = '/analyze/dashboard'

  return (
    <div className='w-100 mw-500px mx-auto text-center'>
      {/* begin::Title */}
      <h1 className='fw-bolder fs-2hx text-gray-900 mb-4'>Access Denied!</h1>
      {/* end::Title */}

      {/* begin::Text */}
      <div className='fs-4 text-gray-700 mb-7'>
        We are sorry, but you do not have the right permission to view this page. If you believe you
        should have access contact you account manager or our support team.
      </div>
      {/* end::Text */}

      {/* begin::Link */}
      <div className='mb-0'>
        <Link to={dashboardUrl} className='btn btn-primary'>
          GO TO HOME PAGE
        </Link>
      </div>
      {/* end::Link */}
    </div>
  )
}

export {Forbidden}
